import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  MenuItem,
} from "@mui/material";
import { createnewTag } from "../../DAL/create";
import { updateAgencyStatus, updateTag } from "../../DAL/update";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

export default function ChangeStatusModel({ open, setOpen, Modeldata }) {
  const [status, setStatus] = React.useState(Modeldata?.status || "");
  const [id, setId] = React.useState(Modeldata?.id || "");
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    setStatus(Modeldata?.status || "");

    setId(Modeldata?.id || "");
  }, [Modeldata]);

  const handleClose = () => {
    setOpen(false);
    // Reset fields when modal is closed
    setStatus("");

    setId("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { status };

      const resp = await updateAgencyStatus(id, payload);
      if (resp?.status == 200) {
        enqueueSnackbar(`Successfully ${resp?.data?.status} `, {
          variant: "success",
        });
        setOpen(false);
      } else {
        enqueueSnackbar(resp?.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("find error", { variant: "error" });
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={style}>
        <Typography id="modal-title" variant="h6" component="h2">
          Change Status
        </Typography>

        <TextField
          select
          fullWidth
          required
          label="Status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          variant="outlined"
          name="status"
          sx={{ marginBottom: 2 }}
        >
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Active">Active</MenuItem>
          <MenuItem value="Blocked">Block</MenuItem>
        </TextField>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Button
            type="button"
            variant="contained"
            sx={{ backgroundColor: "#B1B1B1", textTransform: "none" }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            type="submit"
            variant="contained"
            className="gradientButton"
            sx={{ textTransform: "none" }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
